import SingleSelectQuestion from "./components/default-components/SingleSelectQuestion.vue";
import ConfirmQuestion from "./components/default-components/ConfirmQuestion.vue";
import TextQuestion from "./components/default-components/TextQuestion.vue";
import TextAreaQuestion from "./components/default-components/TextAreaQuestion.vue";
import ReviewQuestion from "./components/default-components/ReviewQuestion.vue";
import ClinicianSelection from "./components/default-components/ClinicianSelection.vue";
import ImageUpload from "./components/default-components/ImageUpload.vue";
import SliderQuestion from "./components/default-components/SliderQuestion.vue";
import DateTimeQuestion from "./components/default-components/DateTimeQuestion.vue";
import Location from "./components/default-components/Location.vue";
import ClinicianTypeMatchQuestion from "./components/default-components/ClinicianTypeMatchQuestion.vue";
import GPOverrideQuestion from "./components/default-components/GPOverrideQuestion.vue";
import MultiSelect from "./components/default-components/MultiSelect.vue";

export default {
  // question_type → component. Note that file names in this SDK are inverted
  // relative to up-spa: SDK's TextQuestion is the display-only block (matches
  // up-spa's ConfirmQuestion.vue), and SDK's ConfirmQuestion is the form
  // (matches up-spa's TextQuestion.vue). The mapping below is by behaviour.
  text: TextQuestion, // display-only sub_text block
  confirm: ConfirmQuestion, // form with field_keys
  select: SingleSelectQuestion,
  review: ReviewQuestion,
  clinician: ClinicianSelection,
  image_upload: ImageUpload,
  text_input: TextAreaQuestion,
  text_area: TextAreaQuestion,
  slider: SliderQuestion,
  date_time: DateTimeQuestion,
  location_detection: Location,
  clinician_type_match: ClinicianTypeMatchQuestion,
  gp_override: GPOverrideQuestion,
  multi_select: MultiSelect
};
